import React from 'react';
import { HStack, StackProps } from '@chakra-ui/react';

const InputGroup: React.FC<StackProps> = ({ children, ...rest }) => {
  return (
    <HStack w="100%" alignItems="flex-end" {...rest}>
      {children}
    </HStack>
  );
};

export default InputGroup;
